<template>
  <div class="flex flex-col w-full h-[100vh] items-center justify-center p-8">
    <div class="flex flex-col w-full max-w-screen-sm">
      <ExclamationTriangleIcon class="w-10 h-10 text-argus-error mb-6" />
      <template v-if="showRedirect">
        <p class="text-argus-forest-800 text-2xl mb-3 font-semibold">Are you lost?</p>
        <p class="text-argus-forest-600">
          It looks like you're trying to access a page that requires a special link sent to your
          email.
        </p>
        <p class="text-argus-forest-600 mb-3">
          To continue, please check your inbox and click the link we sent you.
        </p>

        <p class="text-argus-forest-800 text-lg font-semibold my-3">Not seeing the email?</p>
        <ol class="list-disc list-inside">
          <li class="text-argus-forest-600">Check your spam or junk folder</li>
          <li class="text-argus-forest-600">
            Make sure you're using the most recent email we sent
          </li>
          <li class="text-argus-forest-600">Try searching your inbox for our company name</li>
        </ol>
      </template>
      <template v-else>
        <h5 class="text-argus-error text-2xl mb-3">
          {{ code ? `Error: ${code}` : 'General Error' }}
        </h5>
        <p class="text-argus-error">{{ errorDetail ? errorDetail : 'An error has occurred.' }}</p>
      </template>
    </div>
  </div>
</template>
<script>
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'

export default {
  components: {
    ExclamationTriangleIcon,
  },
  data() {
    return {
      code: null,
      showRedirect: false,
      errorDetail: '',
    }
  },
  mounted() {
    this.code = this.$route.params.code
    this.errorDetail = this.$route.query.detail

    if (this.$route.name === '404' && location.origin.includes('agent')) {
      this.$router.push({ name: 'agent_login' })
    }

    if (!this.code) {
      this.showRedirect = true
    }
  },
}
</script>
